module.exports = "<p>\r\n  showclient works!\r\n</p>\r\n"